const themes = {
  lucky: {
    name: "Lucky Spin",
    logo: "/img/themes/lucky/logo.png",
    favicon: "/img/themes/lucky/favicon.ico",

    cssVars: {
      "--primary-color": "#007AFF",
      "--accent-color": "#00F0FF",
      "--bg-color": "#00031a",
      "--header-bg": `linear-gradient(90.64deg, #1C1D2C 1.63%, #181C3E 99.76%)`,
      "--header-nav-bg": "linear-gradient(270.06deg, #455565 0.05%, #78848F 52.43%, #BAC0C4 99.95%)",
      "--btn-hover-color": "#007AFF",
      "--btn-bg": `linear-gradient(90.64deg, #1C1D2C 1.63%, #181C3E 99.76%)`,
      "--landing-body-bg-layout": "#00031a",
      "--btn-langue-bg": "white",
      "--footer-bg-color": "#ffffff1b",
      "--bg-body": "#00031a",
      "--btn-user-sign-bg": "linear-gradient(93.67deg, #007AFF 2.87%, #00F0FF 100%)",
    },
  },

  default: {
    name: "Lucky Spin",
    logo: "/img/themes/default/logo.png",
    favicon: "/img/themes/default/favicon.ico",
    cssVars: {
      "--primary-color": "#FFD700",
      "--accent-color": "#FF8C00",
      "--bg-color": "#0a0800",
      "--header-bg": `linear-gradient(90.64deg, #1C1D2C 1.63%, #0a0800 99.76%)`,
      "--header-nav-bg": "#2d1a00",
      "--btn-hover-color": "#FFD700",
      "--bg-body": "#0a0800",
      "--btn-bg": "linear-gradient(90.64deg, #1C1400 1.63%, #2D1A00 99.76%)",
      "--landing-body-bg-layout": "#0a0800",
      "--btn-langue-bg": "white",
      "--footer-bg-color": "#0a0800",
      "--btn-user-sign-bg": "linear-gradient(93.67deg, #FFD700 2.87%, #FF8C00 100%)"
    },
  },
};




export const getTheme = () => {
  const brand = process.env.REACT_APP_BRAND || "default";
  return themes[brand] || themes.default;
};